<template>
  <div class="summaryGeneral">
    <div class="summaryGeneral__header">
      <div class="summaryGeneral__header__title">Datos Generales</div>
      <div class="summaryGeneral__header__subtitle">
        {{ season }}
      </div>
    </div>
    <div class="summaryGeneral__table">
      <div class="summaryGeneral__table__lefttable">
        <div class="summaryGeneral__table__lefttable__row">
          <template v-if="type == 1">
            <div class="summaryGeneral__table__lefttable__row__title">Titular:</div>
            <div class="summaryGeneral__table__lefttable__row__val">
              {{ match['games_as_titular'] }} / {{ match['games_as_bench'] + match['games_as_titular'] }}
              <span class="summaryGeneral__table__lefttable__row__val__gray">partidos</span>
            </div>
          </template>
          <template v-else>
            <div class="summaryGeneral__table__lefttable__row__title">Posición en la tabla:</div>
            <div class="summaryGeneral__table__lefttable__row__val">
              {{ match['ranking'] }}
            </div>
          </template>
        </div>
        <div class="summaryGeneral__table__lefttable__sep"></div>
        <div class="summaryGeneral__table__lefttable__row">
          <template v-if="type == 1">
            <div class="summaryGeneral__table__lefttable__row__title">Minutos jugados:</div>
            <div class="summaryGeneral__table__lefttable__row__val">{{ match['minutesPlayed'] }}</div>
          </template>
          <template v-else>
            <div class="summaryGeneral__table__lefttable__row__title">Goles Anotados:</div>
            <div class="summaryGeneral__table__lefttable__row__val">{{ match['goals'] }}</div>
          </template>
        </div>
        <div class="summaryGeneral__table__lefttable__sep"></div>
        <div class="summaryGeneral__table__lefttable__row">
          <template v-if="type == 1">
            <template v-if="position != 1">
              <div class="summaryGeneral__table__lefttable__row__title">Goles:</div>
              <div class="summaryGeneral__table__lefttable__row__val">{{ match['goals'] }}</div>
            </template>
            <template v-else>
              <div class="summaryGeneral__table__lefttable__row__title">Tarjetas amarillas:</div>
              <div class="summaryGeneral__table__lefttable__row__val">{{ match['yellow_cards'] }}</div>
            </template>
          </template>
          <template v-else>
            <div class="summaryGeneral__table__lefttable__row__title">Goles Recibidos:</div>
            <div class="summaryGeneral__table__lefttable__row__val">{{ match['goals_received'] }}</div>
          </template>
        </div>
        <div class="summaryGeneral__table__lefttable__sep"></div>
        <div class="summaryGeneral__table__lefttable__row">
          <template v-if="type == 1">
            <template v-if="position != 1">
              <div class="summaryGeneral__table__lefttable__row__title">Tarjetas amarillas:</div>
              <div class="summaryGeneral__table__lefttable__row__val">{{ match['yellow_cards'] }}</div>
            </template>
            <template v-else>
              <div class="summaryGeneral__table__lefttable__row__title">Tarjetas rojas:</div>
              <div class="summaryGeneral__table__lefttable__row__val">{{ match['red_cards'] }}</div>
            </template>
          </template>
          <template v-else>
            <div class="summaryGeneral__table__lefttable__row__title">xG:</div>
            <div class="summaryGeneral__table__lefttable__row__val" v-if="match['xg']">
              {{ match['xg'].toFixed(2) }}
            </div>
          </template>
        </div>
      </div>

      <div class="summaryGeneral__table__righttable">
        <div class="summaryGeneral__table__righttable__sep flag-movil" v-if="type == 1"></div>
        <div class="summaryGeneral__table__righttable__row" v-if="type == 1 && position != 1">
          <div class="summaryGeneral__table__righttable__row__title">Tarjetas rojas:</div>
          <div class="summaryGeneral__table__righttable__row__val">{{ match['red_cards'] }}</div>
        </div>
        <template v-if="type == 1">
          <template v-if="match['extra_categories']">
            <template v-for="(item, index) in match['extra_categories']">
              <div
                :key="index + 'g'"
                class="summaryGeneral__table__righttable__sep"
                :class="type == 1 && position == 1 && index == 0 ? 'flag-movil' : ''"
              ></div>
              <div :key="index + 'g-r'" class="summaryGeneral__table__righttable__row">
                <div class="summaryGeneral__table__righttable__row__title">{{ item.category_name }}:</div>
                <div class="summaryGeneral__table__righttable__row__val">
                  <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                  ><template v-else>{{ item.total }}</template>
                </div>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="match['extra_categories']">
            <template v-for="(item, index) in match['extra_categories']">
              <template v-if="index >= 2">
                <div
                  :key="index + 'g'"
                  class="summaryGeneral__table__righttable__sep"
                  :class="index == 2 ? 'flag-movil' : ''"
                ></div>
                <div :key="index + 'g-r'" class="summaryGeneral__table__righttable__row">
                  <div class="summaryGeneral__table__righttable__row__title">{{ item.category_name }}:</div>
                  <div class="summaryGeneral__table__righttable__row__val">
                    <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                    ><template v-else>{{ item.total }}</template>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryGeneral',

  props: {
    match: {
      type: Array,
      default: () => [],
    },
    position: {
      type: Number,
      default: 1,
    },
    type: {
      type: Number,
      default: 1,
    },
    season: {
      type: String,
      default: '',
    },
  },
};
</script>
<style></style>
<style scoped lang="scss">
.flag-movil {
  display: none;
  @media screen and (max-width: 500px) {
    display: inline-block;
  }
}
.summaryGeneral {
  width: 100%;
  height: auto;
  // background: purple;
  display: inline-block;
  &__header {
    width: 100%;
    height: 3.158vw;
    border-radius: 4.8px;
    display: inline-flex;
    justify-content: space-between;
    background-color: #132839;
    color: white;
    @media screen and (max-width: 1120px) {
      height: 5.658vw;
    }
    @media screen and (max-width: 768px) {
      height: 7.958vw;
    }
    @media screen and (max-width: 500px) {
      height: 15.958vw;
      display: inline-block;
    }

    &__title {
      font-family: 'Roboto-Black';
      font-size: 1.368vw;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 3.158vw;
      letter-spacing: -0.26px;
      text-align: center;
      color: #cbee6b;
      padding-left: 2.105vw;
      @media screen and (max-width: 1120px) {
        line-height: 5.658vw;
        font-size: 1.968vw;
      }
      @media screen and (max-width: 768px) {
        line-height: 7.958vw;
        font-size: 3vw;
      }
      @media screen and (max-width: 500px) {
        line-height: 7.958vw;
        font-size: 5vw;
        padding-left: 0px;
      }
    }
    &__subtitle {
      font-family: 'Roboto-Regular';
      font-size: 1vw;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 3.158vw;
      letter-spacing: -0.19px;
      text-align: center;
      color: #cbee6b;
      padding-right: 2.105vw;
      @media screen and (max-width: 1120px) {
        line-height: 5.658vw;
        font-size: 1.968vw;
      }
      @media screen and (max-width: 768px) {
        line-height: 7.958vw;
        font-size: 3vw;
      }
      @media screen and (max-width: 500px) {
        line-height: 5.958vw;
        font-size: 3.5vw;
        padding-right: 0px;
      }
      &__bold {
        font-family: 'Roboto-Black';
        padding-left: 1vw;
        font-weight: bold;
        @media screen and (max-width: 500px) {
          padding-left: 3.5vw;
        }
      }
    }
  }
  &__table {
    width: 100%;
    height: auto;
    border-radius: 9.6px;
    border: solid 0.5px #c4c7cb;
    background-color: #fff;
    margin-top: 0.526vw;
    display: inline-flex;
    @media screen and (max-width: 500px) {
      display: inline-block;
      margin-top: 1.926vw;
    }
    &__lefttable {
      width: 50%;
      // background: blue;
      margin-left: 1.053vw;
      margin-right: 1.368vw;
      margin-top: 0.947vw;
      margin-bottom: 0.947vw;

      @media screen and (max-width: 500px) {
        margin-top: 3.87vw;
        margin-bottom: 2vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      @media screen and (max-width: 380px) {
        margin-top: 6vw;
        margin-bottom: 3vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      &__sep {
        width: 100%;
        height: 1px;
        border-bottom: 1px dotted #a2aab7;
        margin-top: 0.5vw;
        margin-bottom: 0.5vw;
        @media screen and (max-width: 500px) {
          width: 90%;
          margin: 0 auto;
          margin-top: 0.5vw;
          margin-bottom: 0.5vw;
          display: inline-block;
        }
      }
      &__row {
        width: 100%;
        height: 3.211vw;
        display: inline-flex;
        justify-content: space-between;
        @media screen and (max-width: 1120px) {
          height: 5.658vw;
        }
        @media screen and (max-width: 768px) {
          height: 9vw;
        }
        @media screen and (max-width: 500px) {
          display: inline-block;
          height: 12vw;
        }
        &__title {
          line-height: 3.211vw;
          font-family: 'Roboto-Regular';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #727a80;
          padding-left: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.258vw;
            line-height: 5vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 4.758vw;
            line-height: 8vw;
            text-align: center;
          }
        }
        &__val {
          line-height: 3.211vw;
          font-family: 'Roboto-Black';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #132839;
          padding-right: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.958vw;
            line-height: 7.8vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 5.958vw;
            line-height: 8vw;
            text-align: center;
          }
          &__gray {
            font-family: 'Roboto-Regular';
            color: #727a80;
          }
        }
      }
    }
    &__righttable {
      width: 50%;
      // background: goldenrod;
      margin-left: 1.053vw;
      margin-right: 1.368vw;
      margin-top: 0.947vw;
      margin-bottom: 0.947vw;
      @media screen and (max-width: 500px) {
        margin-top: -0.98vw;
        margin-bottom: 4vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      @media screen and (max-width: 380px) {
        margin-top: 3vw;
        margin-bottom: 6vw;
        width: 100%;
        margin-left: 0vw;
        margin-right: 0vw;
      }
      &__sep {
        width: 100%;
        height: 1px;
        border-bottom: 1px dotted #a2aab7;
        margin-top: 0.5vw;
        margin-bottom: 0.5vw;
        @media screen and (max-width: 500px) {
          width: 90%;
          margin: 0 auto;
          margin-top: 0.5vw;
          margin-bottom: 0.5vw;
          display: inline-block;
        }
      }
      &__row {
        width: 100%;
        height: 3.211vw;
        display: inline-flex;
        justify-content: space-between;
        @media screen and (max-width: 1120px) {
          height: 5.658vw;
        }
        @media screen and (max-width: 768px) {
          height: 9vw;
        }
        @media screen and (max-width: 500px) {
          height: 12vw;
          display: inline-block;
        }
        &__title {
          line-height: 3.211vw;
          font-family: 'Roboto-Regular';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #727a80;
          padding-left: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.258vw;
            line-height: 5vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 4.758vw;
            line-height: 8vw;
            text-align: center;
          }
        }
        &__val {
          line-height: 3.211vw;
          font-family: 'Roboto-Black';
          font-size: 0.958vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.22px;
          text-align: left;
          color: #132839;
          padding-right: 0.526vw;
          @media screen and (max-width: 1120px) {
            font-size: 1.758vw;
            line-height: 5.658vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.558vw;
            line-height: 9vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 4.958vw;
            line-height: 7.8vw;
            text-align: center;
          }
          @media screen and (max-width: 380px) {
            font-size: 5.958vw;
            line-height: 8vw;
            text-align: center;
          }
          &__gray {
            font-family: 'Roboto-Regular';
            color: #727a80;
          }
        }
      }
    }
  }
}
</style>
